import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { FaArrowRight, FaSeedling, FaGraduationCap, FaCloudSunRain, FaUsers, FaChartLine, FaHandsHelping } from "react-icons/fa";

export default function HomeServices(props) {
    const appContext = useContext(AppContext);
    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    const servicesList = [
        {
            icon: <FaSeedling size={28} />,
            title: "Modern Agricultural Skills",
            desc: "Training smallholder farmers in modern, sustainable techniques to boost productivity and farm yields amidst changing climates."
        },
        {
            icon: <FaCloudSunRain size={28} />,
            title: "Climate Resilience",
            desc: "Promoting sustainable environmental actions and climate adaptation strategies to protect vulnerable communities."
        },
        {
            icon: <FaGraduationCap size={28} />,
            title: "Education & Skills Training",
            desc: "Equipping community members with practical vocational and working skills to enable long-term self-reliance."
        },
        {
            icon: <FaChartLine size={28} />,
            title: "Poverty Alleviation",
            desc: "Fostering sustainable economic opportunities to elevate living standards and ensure a productive community."
        },
        {
            icon: <FaUsers size={28} />,
            title: "Empowering Vulnerable Groups",
            desc: "Targeted support programs dedicated to empowering women, youth, and underprivileged groups for inclusive growth."
        },
        {
            icon: <FaHandsHelping size={28} />,
            title: "Community Capacity Building",
            desc: "Mobilizing local action, leadership, and resources to solve community development challenges collaboratively."
        }
    ];

    if (ready) {
        return (
            <section className="MainBodySection mwadeo-services-wrapper position-relative">
                
                {/* Watermarked Background Icons */}
                <FaSeedling className="watermark-icon watermark-icon-1" />
                <FaCloudSunRain className="watermark-icon watermark-icon-2" />
                <FaGraduationCap className="watermark-icon watermark-icon-3" />
                <FaHandsHelping className="watermark-icon watermark-icon-4" />

                {/* Decorative Floating Circles */}
                <div className="floating-circle floating-circle-1"></div>
                <div className="floating-circle floating-circle-2"></div>

                <div className="container position-relative z-index-2">
                    
                    {/* Header Block */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-12 col-lg-9">
                            <span className="services-kicker text-uppercase font-semi-bold">
                                What We Do • MWADEO
                            </span>
                            <h2 className="title-font-bold services-main-heading">
                                Our Core Areas of <span>Community Intervention</span>
                            </h2>
                            <p className="font-regular services-subtext">
                                Driven by our constitutional mission to lift the standard of living of the poor, we focus on sustainable, 
                                community-led solutions that foster economic thriving and resilience across Tanzania.
                            </p>
                        </div>
                    </div>

                    {/* Clean 3x2 Grid Showcase */}
                    <div className="row g-4 justify-content-center">
                        {servicesList.map((service, idx) => (
                            <div className="col-12 col-md-6 col-lg-4" key={idx}>
                                <div className="mwadeo-service-card">
                                    <span className="card-number title-font-bold">0{idx + 1}</span>
                                    <div className="service-icon-wrapper">
                                        {service.icon}
                                    </div>
                                    <h4 className="title-font-bold service-card-title">
                                        {service.title}
                                    </h4>
                                    <p className="font-regular service-card-desc mb-0">
                                        {service.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Action Button Footer */}
                    <div className="text-center mt-5 pt-4">
                        <button 
                            className="btn btn-mwadeo-services title-font-semi-bold"
                            onClick={() => appContext.navTo({ item: 'services' })}
                        >
                            <span>Explore All Interventions</span>
                            <FaArrowRight size={18} />
                        </button>
                    </div>

                </div>
            </section>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "450px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}